export default "__VITE_ASSET__331f4602__"